<template>
    <ConfirmDialog />
    <Toast position="bottom-right" />
    <router-view />
    <LoadingFullScren v-model:visible="isLoading" />
    <DlgMyPdfPreview v-model:visible="dlgPdfPreviewVisible" :pdfTitle="pdfTitle" :pdfFileName="pdfFileName" :pdfFile="pdfFile" />
</template>

<script setup>
import { provide, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useConfirm } from "primevue/useconfirm";
import { useToast } from 'primevue/usetoast';
import LoadingFullScren from '@/components/LoadingFullScren.vue';
import DlgMyPdfPreview from '@/components/dlgMyPdfPreview.vue';
import { extrairMensagemErro, getDataAtual } from '@/util';

import { useLoading } from '@/components/composables/useLoading';
import { useHistoricoMensagens } from '@/components/composables/useHistoricoMensagens';
const { isLoading } = useLoading();

const confirm = useConfirm();

async function getConfirmacao(vMsg) {
    return new Promise((resolve) => {
        confirm.require({
            message: vMsg,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: () => resolve(true),
            reject: () => resolve(false),
        })
    })
}

const toast = useToast();
const route = useRoute();
const { registrar: registrarNoHistorico } = useHistoricoMensagens();

// Toda mensagem de toast também vai para o histórico (ícone no canto inferior direito).
function exibirMensagem(severity, summary, vMsg) {
    toast.add({ severity, summary, detail: vMsg, life: 4000 });
    registrarNoHistorico(severity, vMsg, route.path);
}

function getMsgInformacao(vMsg) {
    exibirMensagem('info', 'Informação', vMsg);
}
function getMsgAtencao(vMsg) {
    exibirMensagem('warn', 'Atenção!', vMsg);
}
function getMsgErro(vMsg) {
    exibirMensagem('error', 'Erro!', vMsg);
}

function getMsgSucesso(vMsg) {
    exibirMensagem('success', 'Sucesso!', vMsg);
}

// Componente único de preview de PDF pro app inteiro (mesmo padrão de ConfirmDialog/Toast
// acima) — qualquer tela chama a função injetada em vez de replicar os 4 refs +
// try/catch/finally que cada tela de relatório/documento vinha reescrevendo à mão.
const dlgPdfPreviewVisible = ref(false);
const pdfTitle = ref('');
const pdfFileName = ref('');
const pdfFile = ref('');

// funcao: service que retorna { data: base64Pdf } (padrão dos endpoints de relatório).
// parametros: valor único OU array — array é espalhado como múltiplos argumentos de
// funcao(...parametros), permitindo relatórios que precisam de mais de 1 parâmetro.
// nomeBase: título/nome de arquivo sem a data. dataRelatorio (opcional): string
// "DD-MM-YYYY" já formatada pra usar no lugar de hoje — necessário pra telas como o
// Atestado, cujo nome de arquivo reflete a data do próprio documento (values.dtatestado),
// não a data de emissão/impressão.
async function imprimirRelatorio(funcao, parametros, nomeBase, dataRelatorio) {
    try {
        const args = Array.isArray(parametros) ? parametros : [parametros];
        const ret = await funcao(...args);
        const dataFormatada = dataRelatorio || getDataAtual('DD-MM-YYYY');
        pdfTitle.value = `${nomeBase} ${dataFormatada}`;
        pdfFileName.value = `${nomeBase} ${dataFormatada}.pdf`;
        pdfFile.value = ret.data;
        dlgPdfPreviewVisible.value = true;
    } catch (error) {
        getMsgErro(extrairMensagemErro(error, 'Não foi possível gerar o relatório.'));
    }
}

provide('getMsgInformacao', getMsgInformacao);
provide('getMsgAtencao', getMsgAtencao);
provide('getMsgErro', getMsgErro);
provide('getMsgSucesso', getMsgSucesso);
provide('getConfirmacao', getConfirmacao);
provide('imprimirRelatorio', imprimirRelatorio);



</script>
